import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTreeModule } from '@angular/material/tree';
import { ViewsTree } from '../../interfaces/ViewsTree';

@Component({
  selector: 'models-tree',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MatTreeModule,
    MatMenuModule
  ],
  templateUrl: './models-tree.component.html',
  styleUrl: './models-tree.component.scss'
})
export class ModelsTreeComponent{

  ds_models: ViewsTree[] = [];

  readonly childrenAccessor = (node: ViewsTree) => node.children ?? [];
  hasChild = (_: number, node: ViewsTree) => !!node.children && node.children.length > 0;

  @Input() onModelSelected!: Function;
  @Input() menu!: MatMenu
  @Input() edit_mode!: boolean;
  @Input() branchMenu!: MatMenu

  currentBranchSelected!: ViewsTree;

  selectBranch(value: ViewsTree){
    this.currentBranchSelected = value;
  }

  onModel(node: ViewsTree){
    this.currentBranchSelected = node;
    if(this.onModelSelected) this.onModelSelected(node);
  }
}
